/**
 * The non-component half of `./PostSetupTokenGuard`: a module that exports a component
 * may export nothing else, or Vite's Fast Refresh rejects it.
 */
import type { AutheClaims } from "@authe/fe-commons/auth";

/** Mirrors the login SPA: RBAC membership does not mean setup is complete. */
export function needsSetup(claims: AutheClaims | null | undefined): boolean {
  if (claims?.flow_type === "first_login") return true;
  return Array.isArray(claims?.roles) && claims.roles.some(
    (role) => typeof role === "string" && role.endsWith("-SetupBootstrap"),
  );
}
